import React, { useState, useEffect } from "react";
import "./App.css";
//import Scss
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
fakeBackend();
import { Toaster } from "react-hot-toast";
import axios from "axios";
import { LoadingProvider } from "./Context/LoadingContext";
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

const REFRESH_INTERVAL = 40 * 60 * 1000; // Refresh every 40 minutes

function App() {
  const user = JSON.parse(localStorage.getItem("user"));
  console.log("User from localStorage:", user); // Check the user object from localStorage

  const initialToken = user?.token || null;
  const [token, setToken] = useState(initialToken);
  console.log("Initial Token:", initialToken); // Check initial token state

  useEffect(() => {
    if (token) {
      console.log("Setting up token refresh interval"); // Check if the refresh logic runs
      const interval = setInterval(() => {
        console.log("Refreshing token...");
        refreshToken();
      }, REFRESH_INTERVAL);

      return () => {
        console.log("Cleaning up interval"); // Log when the interval is cleared
        clearInterval(interval);
      };
    } else {
      console.log("No token found, skipping token refresh"); // Check if token is missing
    }
  }, [token]);

  const refreshToken = async () => {
    console.log("Attempting to refresh token..."); // Check when token refresh is called
    console.log("Current token:", token); // Log the current token being sent

    try {
      const response = await axios.post(
        "https://api-cosmos-dev.sebs.asia/api/v1/refresh",
        {
          token: token, // Send the current token for refresh
        }
      );

      console.log("Refresh response:", response); // Log the response from the API

      const newToken = response.token;
      if (newToken) {
        setToken(newToken);
        const updatedUser = { ...user, token: newToken };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        console.log("Token refreshed and stored successfully!");
      } else {
        console.error("No new token received in the response");
      }
    } catch (error) {
      console.log("token error", error);
      // // Check if the error is due to an invalid or expired token
      // if (error.response && error.response.data) {
      //   console.error("Error response from server:", error.response.data);
      //   if (error.response.data.error === "could_not_refresh_token") {
      //     console.error("Token expired or invalid, logging user out");
      //     localStorage.removeItem("user");
      //     setToken(null);
      //     // Optionally: redirect to login or show a login modal
      //   }
      // } else {
      //   console.error("Error refreshing token:", error.message); // Log other error details
      // }
    }
  };

  return (
    <React.Fragment>
      {/* {token ? <p>Current Token: {token}</p> : <p>No token available</p>} */}
      <LoadingProvider>
        <Route />
      </LoadingProvider>
      <Toaster />
    </React.Fragment>
  );
}

export default App;
